export default __webpack_public_path__ + "static/media/kitchen3-afterI-1440w.fa218577.avif";